import { render } from "./Land.vue?vue&type=template&id=62a077b0"
import script from "./Land.vue?vue&type=script&lang=js"
export * from "./Land.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/docker/vpn/odessa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__